module.exports = __webpack_public_path__ + "img/novelphone.7e82ae7a.png";